/** Physical Raw Unit options — pure catalog data, ported from `gateway-details/data/raw-units.json` (still used by v1). */
export type RawUnitOption = { label: string; value: string };

export const RAW_UNITS: RawUnitOption[] = [
  { label: '', value: '' },
  { label: '°C', value: '°C' },
  { label: '°F', value: '°F' },
  { label: 'm2', value: 'm2' },
  { label: 'ft2', value: 'ft2' },
  { label: 'm3/h', value: 'm3/h' },
  { label: 'm3/min', value: 'm3/min' },
  { label: 'L/h', value: 'L/h' },
  { label: 'L/min', value: 'L/min' },
  { label: 'gal/h', value: 'gal/h' },
  { label: 'gal/min', value: 'gal/min' },
  { label: 'm3/day', value: 'm3/day' },
  { label: 'gal/day', value: 'gal/day' },
  { label: 'g/L', value: 'g/L' },
  { label: 'mg/L', value: 'mg/L' },
  { label: 'oz/gal', value: 'oz/gal' },
  { label: 'kg/m3', value: 'kg/m3' },
  { label: 'ppm', value: 'ppm' },
  { label: 'lbs/gal', value: 'lbs/gal' },
  { label: 'L', value: 'L' },
  { label: 'm3', value: 'm3' },
  { label: 'gal', value: 'gal' },
  { label: 'decimal', value: 'decimal' },
  { label: '%', value: '%' },
  { label: 'cm', value: 'cm' },
  { label: 'm', value: 'm' },
  { label: 'ft', value: 'ft' },
  { label: 'psi', value: 'psi' },
  { label: 'bar', value: 'bar' },
  { label: 'mbar', value: 'mbar' },
  { label: 'Pa', value: 'Pa' },
  { label: 'KPa', value: 'KPa' },
  { label: 'LMH ', value: 'LMH ' },
  { label: 'GFD ', value: 'GFD ' },
  { label: 'LMH/bar', value: 'LMH/bar' },
  { label: 'LMH/Pa', value: 'LMH/Pa' },
  { label: 'LMH/KPa', value: 'LMH/KPa' },
  { label: 'GFD/psi', value: 'GFD/psi' },
  { label: 'Nm3/h', value: 'Nm3/h' },
  { label: 'SCFM', value: 'SCFM' },
  { label: 'NTU', value: 'NTU' },
  { label: 'FNU', value: 'FNU' },
  { label: 'Ωm', value: 'Ωm' },
  { label: 'S/m', value: 'S/m' },
  { label: 'μS/cm', value: 'μS/cm' },
  { label: 'Hz', value: 'Hz' },
  { label: 'kWh', value: 'kWh' },
  { label: 's', value: 's' },
  { label: 'min', value: 'min' },
  { label: 'h', value: 'h' },
  { label: 'A', value: 'A' },
  { label: 'Nm', value: 'Nm' },
  { label: 'W/m2', value: 'W/m2' },
  { label: 'ppb', value: 'ppb' },
  { label: 'mg', value: 'mg' },
  { label: 'g', value: 'g' },
  { label: 'kg', value: 'kg' },
  { label: 'lbs', value: 'lbs' },
];
